'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = TableRow;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function TableRow(_ref) {
  var _ref$children = _ref.children;
  var children = _ref$children === undefined ? null : _ref$children;
  var _ref$className = _ref.className;
  var className = _ref$className === undefined ? '' : _ref$className;
  var _ref$onClick = _ref.onClick;
  var onClick = _ref$onClick === undefined ? null : _ref$onClick;
  var _ref$style = _ref.style;
  var style = _ref$style === undefined ? {} : _ref$style;

  return _react2['default'].createElement(
    'tr',
    { className: (0, _classnames2['default'])(className, { clickable: onClick }), style: style, onClick: onClick },
    children
  );
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/table/row.js
// module id = 342
// module chunks = 0